import React from 'react';

export function getHighlightParts(string, searchTerm) {
  var tags = searchTerm.split(' ');

  if (!tags?.length) return string;

  const matches = [...string.matchAll(new RegExp(tags.join('|'), 'ig'))];
  const startText = string.slice(0, matches[0]?.index);

  return (
    <span>
      {startText}
      {matches.map((match, i) => {
        const startIndex = match.index;
        const currentText = match[0];
        const endIndex = startIndex + currentText.length;
        const nextIndex = matches[i + 1]?.index;
        const untilNextText = string.slice(endIndex, nextIndex);
        return (
          <span key={i}>
            <mark>{currentText}</mark>
            {untilNextText}
          </span>
        );
      })}
    </span>
  );
}
